export async function updateDontShowAgain({ commit }, dontShowAgain) {
  commit("SET_DONT_SHOW_AGAIN", dontShowAgain);
}
